// POST
export const ENDPOINTS_POST = {
	POST_LOGIN: '/email/login',
	POST_FORGOT: '/email/forgot',
	POST_SET_PASSWORD: '/user'
}

// PUT
export const ENDPOINTS_PUT = {
	PUT_REGISTER: '/email/register',
}

// GET
export const ENDPOINTS_GET = {
	GET_HEALTH_CHECK: 'healthcheck'
}

// DELETE
export const ENDPOINTS_DELETE = {
}